import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IIntervention } from "../../utils/types/models";

export default createEntityReducer<IIntervention>(Endpoint.ToBePlannedInterventions);
